import React, { useState } from 'react';
import { CardTW } from '../../../../tailwindComponents/CardTW/CardTW';
import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import { ContractualDatesAndExpensesSection } from './ContractualDatesAndExpensesSection';
import { UUID } from '../../../../types/shared/UUID';
import { BrokerageAgentsSection } from './BrokerageAgentsSection';
import { IOrderAttributesData } from '../../../../types/order/attributes/IOrderAttributesData';
import { PropertyTitleSection } from './PropertyTitleSection';

export interface IOrderAttributesSectionsProps {
  orderId: UUID;
  orderOpenDate: Date;
  attributes?: IOrderAttributesData;
}

export const OrderAttributesSections: React.FC<IOrderAttributesSectionsProps> = ({
  orderId,
  orderOpenDate,
  attributes,
}) => {
  const [isEmdCollapsed, setIsEmdCollapsed] = useState(false);
  const [isEmdEditMode, setIsEmdEditMode] = useState(false);
  const [isBrokerageAgentsCollapsed, setIsBrokerageAgentsCollapsed] = useState(false);
  const [isBrokerageAgentsEditMode, setIsBrokerageAgentsEditMode] = useState(false);
  const [isPropertyTitleCollapsed, setIsPropertyTitleCollapsed] = useState(false);
  const [isPropertyTitleEditMode, setIsPropertyTitleEditMode] = useState(false);

  const handleAllExpand = () => {
    if (isEmdEditMode || isBrokerageAgentsEditMode) {
      return;
    }
    if (isEmdCollapsed && isBrokerageAgentsCollapsed) {
      setIsEmdCollapsed(false);
      setIsBrokerageAgentsCollapsed(false);
      setIsPropertyTitleCollapsed(false);
      return;
    }
    setIsEmdCollapsed(true);
    setIsBrokerageAgentsCollapsed(true);
    setIsPropertyTitleCollapsed(true);
  };

  return (
    <CardTW
      title={'Order Attributes'}
      titleActions={
        <div className={'ml-auto flex items-center pr-8'}>
          <ButtonTW secondary onClick={handleAllExpand}>
            {isEmdCollapsed && isBrokerageAgentsCollapsed ? 'Expand All' : 'Collapse All'}
          </ButtonTW>
        </div>
      }
      isCollapsible={false}
    >
      <BrokerageAgentsSection
        orderId={orderId}
        attributes={attributes}
        isCollapsed={isBrokerageAgentsCollapsed}
        setIsCollapsed={setIsBrokerageAgentsCollapsed}
        isEditMode={isBrokerageAgentsEditMode}
        setIsEditMode={setIsBrokerageAgentsEditMode}
      />
      <ContractualDatesAndExpensesSection
        orderId={orderId}
        orderOpenDate={orderOpenDate}
        attributes={attributes}
        isCollapsed={isEmdCollapsed}
        setIsCollapsed={setIsEmdCollapsed}
        isEditMode={isEmdEditMode}
        setIsEditMode={setIsEmdEditMode}
      />
      <PropertyTitleSection
        orderId={orderId}
        attributes={attributes}
        isCollapsed={isPropertyTitleCollapsed}
        setIsCollapsed={setIsPropertyTitleCollapsed}
        isEditMode={isPropertyTitleEditMode}
        setIsEditMode={setIsPropertyTitleEditMode}
      />
    </CardTW>
  );
};
